/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber4Small = createReactComponent("number-4-small", "IconNumber4Small", [
  ["path", { d: "M10 8v3a1 1 0 0 0 1 1h3", key: "svg-0" }],
  ["path", { d: "M14 8v8", key: "svg-1" }]
]);

export { IconNumber4Small as default };
//# sourceMappingURL=IconNumber4Small.js.map
